import * as React from "react";
import { Stack, Typography, Link, Tooltip } from "@mui/material";
import Divider from "@mui/material/Divider";
import { LinguisticQualityReviewResult } from "gen/clients";
import { StarRating } from "components/StarRating/StarRating";

interface Props {
  /**
   * The linguistic quality review result to display
   */
  reviewResult: LinguisticQualityReviewResult;
  /**
   * The name of the language being reviewed (for display purposes)
   */
  languageName: string;
}

const LinguisticQualityReview: React.FC<Props> = ({ reviewResult, languageName }) => {
  return (
    <Stack sx={{ mt: "auto", pt: 2 }}>
      <Divider sx={{ mb: 2 }} />
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1} sx={{ flexWrap: "wrap" }}>
        <Typography variant="body2" color="text.primary">
          Linguistic Quality (AI-Assessed) - {languageName}
        </Typography>
        <Stack spacing={1} direction="row" alignItems="center" pr={2}>
          <StarRating rating={reviewResult.score} size="small" />
          <Typography variant="body2" color="text.secondary">
            ({reviewResult.score})
          </Typography>
          {reviewResult.scoreReason && (
            <Tooltip
              title={
                <Typography variant="body2" sx={{ maxWidth: 500, whiteSpace: "pre-wrap" }}>
                  {reviewResult.scoreReason}
                </Typography>
              }
              arrow
              placement="top"
            >
              <Link
                component="button"
                variant="body2"
                sx={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  color: "primary.main",
                  "&:hover": {
                    textDecoration: "underline"
                  }
                }}
              >
                Learn more
              </Link>
            </Tooltip>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export { LinguisticQualityReview };
